import { render, staticRenderFns } from "./MyReturnReceipt.vue?vue&type=template&id=51c0cd21&scoped=true&"
import script from "./MyReturnReceipt.vue?vue&type=script&lang=js&"
export * from "./MyReturnReceipt.vue?vue&type=script&lang=js&"
import style0 from "./MyReturnReceipt.vue?vue&type=style&index=0&id=51c0cd21&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c0cd21",
  null
  
)

export default component.exports